import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'

import { IS_PRODUCTION } from 'utils/helperConfig'

import { rootApi } from './api'
import rootReducer from './rootReducer'
import rootSaga from './rootSaga'

const sagaMiddleware = createSagaMiddleware()
const middleware = [sagaMiddleware, rootApi.middleware]

export const store = configureStore({
    reducer: {
        [rootApi.reducerPath]: rootApi.reducer,
        ...rootReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middleware),
    devTools: !IS_PRODUCTION,
})

sagaMiddleware.run(rootSaga)

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
